module.exports = __webpack_public_path__ + "static/img/215.9fead25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/215.png
// module id = X+3F
// module chunks = 1